const carouselItems = [
  {
    img: "https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20image%20showing%20an%20action%20thriller%20theme%20with%20dramatic%20lighting%2C%20warm%20golden%20and%20coral%20tones%2C%20silhouetted%20figures%20in%20motion%2C%20professional%20film%20promotional%20aesthetic%2C%20clean%20composition%20with%20negative%20space%20for%20text%2C%20high%20contrast%2C%20editorial%20quality%2C%20movie%20genre%20atmosphere&width=800&height=450&seq=carousel-01&orientation=landscape",
    tag: '动作大片',
    title: '暑期档动作巨制集中上线，肾上腺素飙升的热血盛宴',
    desc: '多部高口碑动作电影本周同步更新，涵盖警匪、特工、冒险等热门题材，每一帧都燃到极致。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20warm%20and%20intimate%20romance%20drama%20film%20scene%20with%20two%20figures%20in%20a%20city%20at%20sunset%2C%20soft%20golden%20hour%20lighting%2C%20cinematic%20depth%20of%20field%2C%20emotional%20storytelling%20mood%2C%20warm%20amber%20and%20rose%20tones%2C%20professional%20film%20photography%2C%20clean%20composition%2C%20editorial%20quality&width=800&height=450&seq=carousel-02&orientation=landscape",
    tag: '高分剧集',
    title: '豆瓣评分9.0+悬疑神作回归，剧情反转再反转',
    desc: '口碑炸裂的烧脑悬疑剧新季开播，层层递进的叙事结构让观众直呼过瘾，追剧停不下来。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20vibrant%20and%20colorful%20animated%20film%20scene%20with%20stylized%20characters%20in%20a%20fantasy%20world%2C%20bright%20warm%20colors%2C%20soft%20illustration%20style%2C%20whimsical%20atmosphere%2C%20professional%20animation%20art%20direction%2C%20clean%20composition%2C%20high%20detail%2C%20editorial%20quality&width=800&height=450&seq=carousel-03&orientation=landscape",
    tag: '国漫崛起',
    title: '国产动画电影年度盘点：口碑与票房双双破纪录',
    desc: '从热血战斗到治愈日常，今年上线的国漫作品质量全面跃升，制作精良、故事扎实，值得每一部都追。',
  },
  {
    img: "https://readdy.ai/api/search-image?query=A%20variety%20show%20stage%20set%20with%20colorful%20lighting%20and%20performers%20in%20dynamic%20poses%2C%20entertaining%20atmosphere%2C%20warm%20stage%20lights%2C%20professional%20television%20production%20aesthetic%2C%20clean%20composition%2C%20editorial%20quality%2C%20high%20detail%2C%20celebratory%20mood&width=800&height=450&seq=carousel-04&orientation=landscape",
    tag: '综艺热播',
    title: '旅行慢综艺扎堆上线，治愈系内容成观众新宠',
    desc: '告别快节奏竞技，多档人文旅行类综艺用慢镜头和真实对话打动观众，收视率持续走高。',
  },
];

export function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          焦点推荐
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className="group relative bg-background-100 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-accent-300/60 transition-colors"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-6">
          关于桃花
        </h2>
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-foreground-700 leading-relaxed text-sm md:text-base mb-4">
            桃花视频是一个专注于<strong>免费在线影视观看</strong>的综合平台，汇集<strong>91视频、91视频网站、久久视频、91在线视频</strong>等丰富资源。我们以"让每个人都能轻松看好片"为使命，持续收录最新电影、热播电视剧、人气综艺、高口碑动漫等全品类内容。
          </p>
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            平台采用先进的视频分发技术，确保<strong>高清全集不缓冲</strong>的流畅观影体验。内容团队每日精选更新，无论你是动作片爱好者、悬疑剧迷、还是国漫粉丝，都能在这里找到心头好。桃花视频，陪你度过每一个追剧的夜晚。
          </p>
        </div>
      </div>
    </section>
  );
}

export function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-6">
          合作联系
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6 text-center">
              如果你有影视资源合作、内容投稿、广告投放等需求，欢迎通过以下方式与我们取得联系。桃花视频团队期待与优质内容方携手，为观众带来更多精彩的<strong>91在线视频</strong>体验。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex flex-col items-center p-4 rounded-lg bg-background-50 border border-background-200/50">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-lg"></i>
                </span>
                <span className="text-xs text-foreground-600 mb-1">商务合作</span>
                <span className="text-sm font-medium text-foreground-900">bd@taohua.video</span>
              </div>
              <div className="flex flex-col items-center p-4 rounded-lg bg-background-50 border border-background-200/50">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-edit-line text-lg"></i>
                </span>
                <span className="text-xs text-foreground-600 mb-1">内容投稿</span>
                <span className="text-sm font-medium text-foreground-900">contribute@taohua.video</span>
              </div>
              <div className="flex flex-col items-center p-4 rounded-lg bg-background-50 border border-background-200/50">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-customer-service-line text-lg"></i>
                </span>
                <span className="text-xs text-foreground-600 mb-1">用户反馈</span>
                <span className="text-sm font-medium text-foreground-900">feedback@taohua.video</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const updates = [
  { date: '07.30', tag: '新片上线', title: '《逆光追凶》1080P高清完整版已更新，悬疑犯罪题材口碑之作', type: 'film' },
  { date: '07.29', tag: '剧集更新', title: '《星河万里》第28-30集上线，古装仙侠大结局引热议', type: 'drama' },
  { date: '07.28', tag: '综艺上线', title: '《说走就走第三季》最新期已更新，嘉宾阵容全面升级', type: 'variety' },
  { date: '07.27', tag: '动漫更新', title: '《星域纪元》夏季特别篇上线，制作水准再创新高', type: 'anime' },
  { date: '07.26', tag: '片单推荐', title: '本周必看TOP10发布：「暑期档最强片单」观影指南', type: 'list' },
  { date: '07.25', tag: '新片上线', title: '韩国悬疑神作《迷雾追踪》全网首播，豆瓣开分9.1', type: 'film' },
  { date: '07.24', tag: '站内公告', title: '播放器升级完成，全站支持4K超清画质与杜比音效', type: 'notice' },
];

export function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-10">
          最新片单
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-300">
            {updates.map((item, i) => (
              <div key={i} className={`relative mb-8 last:mb-0 ${i === 0 ? 'animate-pulse' : ''}`}>
                <span className={`absolute -left-[calc(2rem+5px)] top-0 w-2.5 h-2.5 rounded-full border-2 ${
                  i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-100 border-background-300'
                }`}></span>
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <time className="text-xs font-medium text-accent-600 whitespace-nowrap">{item.date}</time>
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  {i === 0 && (
                    <span className="px-2 py-0.5 rounded-full text-xs bg-primary-100 text-primary-700 whitespace-nowrap">NEW</span>
                  )}
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}